export default __webpack_public_path__ + "static/media/character.15b06d3b.png";